'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { ArrowUpDown } from 'lucide-react';
import { useState } from 'react';
import { METRIC_OPTIONS, type MetricWithoutBudget } from '@/modules/finances/types';
import { BasicSelect } from '@/modules/shared/components/basic-select/basic-select';
import { FilterDrawer } from '@/modules/shared/components/filter-drawer/filter-drawer';
import { MetricSelectDrawer } from '../metric-budget-filters/metric-select-drawer';
import { BudgetStatementPopover } from './budget-statement-popover';
import { StatusSelectBudget, StatusSelectDrawer } from './budget-statement-status';
import { MetricItemFilter } from './metric-item-filter';
import { useBudgetStatementFilters } from './use-budget-statement-filters';
function BudgetStatementFilters() {
  const $ = _c(78);
  const [open, setOpen] = useState(false);
  const {
    status,
    setStatus,
    metricSort,
    metric,
    setMetric,
    onReset,
    handleOnMetricSelect,
    isStatusPending,
    isMetricPending,
    isResetPending,
    isResetDisabled
  } = useBudgetStatementFilters();
  let t0;
  if ($[0] !== setMetric) {
    t0 = value => {
      setMetric(value as MetricWithoutBudget);
    };
    $[0] = setMetric;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.values(METRIC_OPTIONS).filter(_temp);
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isMetricPending || $[4] !== isResetPending || $[5] !== metric || $[6] !== t0) {
    t2 = <BasicSelect key={metric} value={metric} label="Metric" onValueChange={t0} options={t1} placeholder="Budget" className="md:w-48 lg:w-65" isLoading={isMetricPending} disabled={isResetPending} matchTriggerWidth={true} />;
    $[3] = isMetricPending;
    $[4] = isResetPending;
    $[5] = metric;
    $[6] = t0;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== isResetPending || $[9] !== isStatusPending || $[10] !== setStatus || $[11] !== status) {
    t3 = <StatusSelectBudget status={status} setStatus={setStatus} className="md:w-27 lg:w-46" isLoading={isStatusPending} disabled={isResetPending} />;
    $[8] = isResetPending;
    $[9] = isStatusPending;
    $[10] = setStatus;
    $[11] = status;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== isResetDisabled || $[14] !== onReset) {
    t4 = <Button className="text-foreground/50 px-4 hover:bg-transparent dark:hover:bg-transparent" variant="ghost" onClick={onReset} disabled={isResetDisabled}>Reset Filter</Button>;
    $[13] = isResetDisabled;
    $[14] = onReset;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
    t5 = <div className="hidden items-center gap-4 md:flex">{t2}{t3}{t4}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== setStatus || $[21] !== status) {
    t6 = <StatusSelectDrawer status={status} setStatus={setStatus} />;
    $[20] = setStatus;
    $[21] = status;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== metric || $[24] !== setMetric) {
    t7 = <MetricSelectDrawer metric={metric} setMetric={setMetric} />;
    $[23] = metric;
    $[24] = setMetric;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== onReset || $[27] !== t6 || $[28] !== t7) {
    t8 = <div className="flex items-center gap-4 md:hidden"><FilterDrawer onReset={onReset}>{t6}{t7}</FilterDrawer></div>;
    $[26] = onReset;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== handleOnMetricSelect || $[31] !== metricSort || $[32] !== open) {
    t9 = <BudgetStatementPopover className="hidden md:flex" handleOnMetricSelect={handleOnMetricSelect} metric={metricSort} open={open} setOpen={setOpen} />;
    $[30] = handleOnMetricSelect;
    $[31] = metricSort;
    $[32] = open;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Button variant="ghost" size="icon" className="h-8 w-8"><ArrowUpDown className="size-4.5" /></Button>;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="text-foreground text-sm font-semibold">Sort by</span>;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== handleOnMetricSelect) {
    t12 = <div className="flex items-center justify-between px-2 pt-2 pb-1">{t11}<Button variant="ghost" onClick={() => {
        handleOnMetricSelect("modified_newest");
      }} className="text-muted-foreground hover:text-foreground text-sm transition-colors outline-none">Reset</Button></div>;
    $[36] = handleOnMetricSelect;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="text-muted-foreground/80 px-2 py-1.5 text-xs font-semibold">Reporting Month</div>;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  const t14 = metricSort === "reporting_newest";
  let t15;
  if ($[39] !== handleOnMetricSelect) {
    t15 = () => {
      handleOnMetricSelect("reporting_newest");
    };
    $[39] = handleOnMetricSelect;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t14 || $[42] !== t15) {
    t16 = <MetricItemFilter label="Newest First" isSelected={t14} onClick={t15} />;
    $[41] = t14;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  const t17 = metricSort === "reporting_oldest";
  let t18;
  if ($[44] !== handleOnMetricSelect) {
    t18 = () => {
      handleOnMetricSelect("reporting_oldest");
    };
    $[44] = handleOnMetricSelect;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t17 || $[47] !== t18) {
    t19 = <MetricItemFilter label="Oldest First" isSelected={t17} onClick={t18} />;
    $[46] = t17;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="text-muted-foreground/80 mt-2 px-2 py-1.5 text-xs font-semibold">Last Modified</div>;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  const t21 = metricSort === "modified_newest";
  let t22;
  if ($[50] !== handleOnMetricSelect) {
    t22 = () => {
      handleOnMetricSelect("modified_newest");
    };
    $[50] = handleOnMetricSelect;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t21 || $[53] !== t22) {
    t23 = <MetricItemFilter label="Newest First" isSelected={t21} onClick={t22} />;
    $[52] = t21;
    $[53] = t22;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  const t24 = metricSort === "modified_oldest";
  let t25;
  if ($[55] !== handleOnMetricSelect) {
    t25 = () => {
      handleOnMetricSelect("modified_oldest");
    };
    $[55] = handleOnMetricSelect;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t24 || $[58] !== t25) {
    t26 = <MetricItemFilter label="Oldest First" isSelected={t24} onClick={t25} />;
    $[57] = t24;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t12 || $[61] !== t16 || $[62] !== t19 || $[63] !== t23 || $[64] !== t26) {
    t27 = <div className="border-input flex flex-col gap-1 rounded-xl border p-2">{t12}{t13}{t16}{t19}{t20}{t23}{t26}</div>;
    $[60] = t12;
    $[61] = t16;
    $[62] = t19;
    $[63] = t23;
    $[64] = t26;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  let t28;
  if ($[66] !== onReset || $[67] !== t27) {
    t28 = <div className="flex md:hidden"><FilterDrawer onReset={onReset} filterTrigger={t10}>{t27}</FilterDrawer></div>;
    $[66] = onReset;
    $[67] = t27;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  let t29;
  if ($[69] !== t28 || $[70] !== t9) {
    t29 = <div className="flex items-center gap-4 lg:hidden">{t9}{t28}</div>;
    $[69] = t28;
    $[70] = t9;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  let t30;
  if ($[72] !== t29 || $[73] !== t8) {
    t30 = <div className="flex gap-4 lg:hidden">{t8}{t29}</div>;
    $[72] = t29;
    $[73] = t8;
    $[74] = t30;
  } else {
    t30 = $[74];
  }
  let t31;
  if ($[75] !== t30 || $[76] !== t5) {
    t31 = <div className="row flex gap-4">{t5}{t30}</div>;
    $[75] = t30;
    $[76] = t5;
    $[77] = t31;
  } else {
    t31 = $[77];
  }
  return t31;
}
function _temp(metric_0) {
  return metric_0 !== "Budget";
}
export { BudgetStatementFilters };